import React, { useEffect,  useState } from "react";
import { TreeTable } from 'primereact/treetable';
import { Column } from 'primereact/column';

import { useHierarchyService } from "../../hooks/useHierarchyService";
import useWindowDimensions from "../../hooks/useWindowDimensions";

import { ExpandAll } from "../../utilities/TreeHelper";
import 'primeflex/primeflex.css';
import '../css/ProTree.css';
import _ from 'lodash'

const ProTreeTable = ({index, treeData,  searchValue, config, OnTreeNodeSelect, defaultSelectionKey = "", defaultExpandedKeys = {}, isFilterApplied = false })=>{ 
    const [selectionKey, setSelectionKey] = useState(defaultSelectionKey);  
    const {data:{expandedKeys, totalBeds, availableBeds}, actions:{SetExpandedKeys}} = useHierarchyService(); 
       const { height } = useWindowDimensions();
    
   
   useEffect(()=>{        
        if(!_.isEmpty(defaultExpandedKeys))
            SetExpandedKeys(index, defaultExpandedKeys) 
   }, [defaultExpandedKeys])

   useEffect(()=>{
        setSelectionKey(defaultSelectionKey)
   }, [defaultSelectionKey])

   useEffect(()=>{      
       let keysToExpand = {}
       !_.isEmpty(searchValue) && _.forEach(treeData, (tree)=>{keysToExpand = {...keysToExpand, ...ExpandAll(tree, keysToExpand)};  SetExpandedKeys(index, keysToExpand)})
      
       if(_.isEmpty(searchValue) && !isFilterApplied)
        SetExpandedKeys(index, expandedKeys[index])   

   }, [searchValue, isFilterApplied])

   useEffect(()=>{
       var element = _.first(document.getElementsByClassName("p-treetable-header")) 
        if(element){   
            if( _.gt(availableBeds, 0))    
                element.className =  `${element.className} p-treetable-header-highlight`
            else
                element.classList.remove("p-treetable-header-highlight")
        }

   }, [availableBeds])

   const rowClassName = (node) => {       
        return  _.isEqual(node.type, "BED") && { 'p-highlight-treenode-bed': node.key === selectionKey } 
                                            //: { 'p-highlight-treenode': node.key === selectionKey } ;
}


    return (   
        <TreeTable  value={treeData}  header={_.gt(totalBeds, 0)?`${availableBeds} of ${totalBeds} Beds Available`:""} stripedRows={true} expandedKeys={expandedKeys[index]} onToggle={(e)=>SetExpandedKeys(index, e.value)} 
                   selectionKeys={selectionKey} selectionMode="single" globalFilter={searchValue} onSelect={OnTreeNodeSelect}
                   onSelectionChange={e=> setSelectionKey(e.value)} rowClassName={rowClassName} scrollable scrollHeight={`${height-200}px`}  > 
               {config.map((c, index)=>{
                   return <Column key={index} body={c.actionTemplate} field={c.field}  expander = {c.expander} style={c.style}></Column>
               })} 
        </TreeTable>
    )
}

export default ProTreeTable;